import { IThunkActionCreator } from '../../index';
import { TModelType } from '../types';
import { requestUserBasedSimilarOffers } from './requestUserBasedSimilarOffers';
import { requestItemBasedSimilarOffers } from './requestItemBasedSimilarOffers';
import { requestHistoryBasedSimilarOffers } from './requestHistoryBasedSimilarOffers';

interface IRequestSimilarOffersParams {
  offerId: number;
  publishedUserId: number;
  modelType: TModelType;
}

export function requestSimilarOffers(params: IRequestSimilarOffersParams): IThunkActionCreator {
  const { offerId, publishedUserId, modelType } = params;

  return dispatch => {
    switch (modelType) {
      case 'userBased':
        return dispatch(requestUserBasedSimilarOffers(offerId, publishedUserId));

      case 'itemBased':
        return dispatch(requestItemBasedSimilarOffers(offerId, publishedUserId));

      case 'historyBased':
        return dispatch(requestHistoryBasedSimilarOffers());
    }
  };
}
